<template>
  <div class="cc page pageAsOverlay">
    <AppHead></AppHead>
    <div v-if="url" class="">
<!--      <div>DEBUG {{ url }}</div>-->
      <iframe style="height: 92vh; width: 100%; background-color: transparent;"
              :src="url"
              sandbox="allow-forms allow-same-origin allow-scripts allow-modals allow-popups"
              frameborder="0"></iframe>
    </div>

  </div>
</template>

<script>
import AppHead from "@/components/AppHead.vue";
import {ebus} from "@/vendor/ebus";
import {getGlobalValue, removeGlobalKey} from "@/util/globalState";

export default {
  name: "IframeOverlay",
  components: {AppHead},
  data: () => ({
    url: '',
  }),
  created() {
    ebus.$on('closedDialogContainer', (name) => {
      if (name === 'IframeOverlay') {
        this.url = '';
      }
    });
    ebus.$on('triggerIframeOverlay', (u) => {
      // alert('triggerIframeOverlay ' + u)
      this.url = u;
    });
  },
  mounted() {
    let ccRedirectUrl = getGlobalValue('ccRedirectUrl');
    if (ccRedirectUrl) {
      this.url = ccRedirectUrl;
      removeGlobalKey('ccRedirectUrl');
    }
  },
}
</script>

<style scoped lang="scss">
.cc {
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 39999;
}

.pageAsOverlay {
  background-color: white;
}
</style>
